import React from 'react';

// @atlaskit
// import DashboardIcon from '@atlaskit/icon/glyph/dashboard';
import { AkNavigationItemGroup, AkNavigationItem } from '@atlaskit/navigation';
import AppSwitcherIcon from '@atlaskit/icon/glyph/app-switcher';
import BitbucketReposIcon from '@atlaskit/icon/glyph/bitbucket/repos';
import FeedbackIcon from '@atlaskit/icon/glyph/feedback';
import GraphLineIcon from '@atlaskit/icon/glyph/graph-line';
import PeopleGroupIcon from '@atlaskit/icon/glyph/people-group';
import SettingsIcon from '@atlaskit/icon/glyph/settings';

// @source
import { account as constant } from '../../../constants';
import { User } from '../../../tools';
import RouteNavLink from '../RouteNavLink';

/* const yourwork = {
  href: '/',
  text: 'Your work',
  icon: DashboardIcon,
  linkComponent: RouteNavLink,
}; */

const reports = {
  href: '/reports',
  text: 'Reports',
  icon: BitbucketReposIcon,
  linkComponent: RouteNavLink,
};

const excel = {
  href: '/excel',
  text: 'Excel',
  icon: AppSwitcherIcon,
  linkComponent: RouteNavLink,
};

const trend = {
  href: '/trend',
  text: 'Trend',
  icon: GraphLineIcon,
  linkComponent: RouteNavLink,
};

const users = {
  href: '/users',
  text: 'Users',
  icon: PeopleGroupIcon,
  linkComponent: RouteNavLink,
};

const settings = {
  href: '/settings',
  text: 'Settings',
  icon: SettingsIcon,
  linkComponent: RouteNavLink,
};

const Stack = (props) => {
  const isMobile = window.outerWidth < 768;
  const account = User.getUserInfo();
  const basepath = `/${window.location.pathname.split('/')[1]}`;

  if (isMobile) {
    account.Type = constant.USER;
  }

  const routes = [{
    key: 'global',
    items: account.Type === constant.USER
      ? [excel, trend]
      : [reports, excel, trend, users, settings],
  },
  {
    title: 'Feedback',
    key: 'feedback',
    items: [
      {
        onClick: props.onToggleFeedback,
        text: 'Give Feedback',
        icon: FeedbackIcon,
      },
    ],
  }];

  const stack = routes.map(({ key, title, items }) => (
    <AkNavigationItemGroup key={key} title={title}>
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <AkNavigationItem
            {...item}
            icon={<Icon label={item.text} size="medium" />}
            isSelected={item.href === basepath}
            key={item.text}
          />
        );
      })}
    </AkNavigationItemGroup>
  ));

  return stack;
};

export default Stack;
